module.exports = __webpack_public_path__ + "img/s3-img3.035735c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s3-img3.png
// module id = 414
// module chunks = 0